import { render, staticRenderFns } from "./editComponent.vue?vue&type=template&id=60eed48e&scoped=true&"
import script from "./editComponent.vue?vue&type=script&lang=js&"
export * from "./editComponent.vue?vue&type=script&lang=js&"
import style0 from "./editComponent.vue?vue&type=style&index=0&id=60eed48e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eed48e",
  null
  
)

export default component.exports